import { ReactElement } from 'react';
import { SocialShareButton } from './SocialShare.styles';
import { SocialShareProps } from './SocialShare.types';

export const SocialShare = ({
  icon,
  socialLink,
  articleLink,
  textPrefix,
  text,
  hoverColor,
  scale,
}: SocialShareProps): ReactElement => {
  const handleClick = () => {
    window.open(
      `${socialLink}${articleLink}${
        textPrefix && text ? `${textPrefix} ${text.replaceAll('%', '')}%0A` : ''
      }`,
      'share-dialog',
      'width=550,height=480',
    );
  };

  return (
    <SocialShareButton type="button" onClick={handleClick} color={hoverColor} scale={scale}>
      {icon}
    </SocialShareButton>
  );
};
